module.exports = __webpack_public_path__ + "img/14.eef319f0.png";